import { render, staticRenderFns } from "./SpedizioniList.vue?vue&type=template&id=3c3826bc"
import script from "./SpedizioniList.vue?vue&type=script&lang=ts"
export * from "./SpedizioniList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c3826bc')) {
      api.createRecord('3c3826bc', component.options)
    } else {
      api.reload('3c3826bc', component.options)
    }
    module.hot.accept("./SpedizioniList.vue?vue&type=template&id=3c3826bc", function () {
      api.rerender('3c3826bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SpedizioniList.vue"
export default component.exports